exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.app-action {\n  display: inline-block;\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n}\n\n\n.sub-toolbar-height {\n  min-height: 3px !important;\n  height: 3px !important;\n  margin-top: 10px !important;\n  margin-bottom: 12px !important;\n  background-color:#673ab7 !important;\n}\n\n.scrollbar {\n  overflow:auto;\n  overflow-x:auto !important;\n  overflow-y:auto !important;\n  height:100%;\n  width:100%;\n  position:absolute;\n}\n\n.row-margin {\n  margin-top: 20px;\n}\n\n.button-align {\n  margin-left: 20px !important;\n}\n\n.error {\n    color: red;\n}\n\n.password-width {\n   width: 80%;\n}\n\nmd-spinner {\n  float: left;\n  width: 35px; \n  height: 35px; \n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/header/usersettings/userpreferences/user-preferences.component.css
// module id = 2014
// module chunks = 0